import { AstraButton, AstraErrorText, AstraParagraph, KeyboardShortcut } from '~/astra'
import { KeyboardShortcutRecorder } from '~/components'

type Props = {
    shortcut: KeyboardShortcut
    onShortcutChange: (shortcut: KeyboardShortcut) => void
    error?: boolean
    errorText?: string
    suggestion: KeyboardShortcut | null
    canSuggest: boolean
    onSuggest: () => void
}

export const KeyboardShortcutField = ({ shortcut, onShortcutChange, error, errorText, suggestion, canSuggest, onSuggest }: Props) => (
    <div className="flex flex-col gap-2">
        <AstraParagraph variant="body-large" weight="medium">
            Tastatur hurtigtast
        </AstraParagraph>

        <div className="grid grid-cols-2 gap-2">
            <div className="flex flex-col gap-1">
                <KeyboardShortcutRecorder shortcut={shortcut} onShortcutChange={onShortcutChange} error={error} />
                <AstraErrorText errorText={errorText} error={error} />
            </div>

            {canSuggest && <AstraButton variant="secondary" label="Foreslå ny" type="button" disabled={!suggestion} onClick={onSuggest} />}
        </div>
    </div>
)
